import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import axios from './axios';

export interface UseOTPRequestVariables {
  phone: string;
}

export interface UseOTPRequestData {}

export interface UseOTPRequestErrorData {}

export function useOTPRequest() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseOTPRequestData,
    AxiosError<UseOTPRequestErrorData>,
    UseOTPRequestVariables
  >(
    (variables) => {
      const data = variables;

      return axios
        .post<UseOTPRequestData>('/posht/ashena/otp/', data)
        .then((res) => res.data);
    },
    {
      onError: (error) => {
        if (error.response?.status === 400) {
          enqueueSnackbar(t('landing.wrongPhone'), { variant: 'error' });
        } else {
          enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
        }
      },
      onSuccess: () => {
        enqueueSnackbar(t('landing.otpSent'), { variant: 'success' });
      },
    },
  );
}
